export default (options) => {
  return {
    applyHtmlTags: ['italics'].map(tag => tag.toLowerCase())
  }
}
